import React from "react";
// import ReactDOM from "react-dom";
import { createRoot } from "react-dom";
import App from "./App";

// ReactDOM.render(<App />, document.getElementById("root"));
createRoot(document.getElementById("root")).render(<App />);
